"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.inventorySearchStore = void 0;
const api_1 = require("client/api");
const mobx_1 = require("mobx");
class InventorySearchStore {
    constructor() {
        this.loading = false;
        this.error = "";
        this.fdb = null;
        this.loadFTS = async (query, type = "multi") => {
            this.loading = true;
            const results = await api_1.NDCEndpoint.fts.apiCall(null, { query, type });
            if (results) {
                this.fdb = results;
                this.error = "";
            }
            else {
                this.fdb = null;
                this.error = "First Databank unable to supply requested package.";
            }
            this.loading = false;
        };
    }
}
__decorate([
    mobx_1.observable
], InventorySearchStore.prototype, "loading", void 0);
__decorate([
    mobx_1.observable
], InventorySearchStore.prototype, "error", void 0);
__decorate([
    mobx_1.observable
], InventorySearchStore.prototype, "fdb", void 0);
__decorate([
    mobx_1.action
], InventorySearchStore.prototype, "loadFTS", void 0);
exports.inventorySearchStore = new InventorySearchStore();



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/modules/inventory-search/store.ts
// module id = 3060
// module chunks = 0